function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "teams_ico-a",
  x1: "17.372%",
  x2: "82.628%",
  y1: "-6.51%",
  y2: "106.51%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#5A62C3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "50%",
  stopColor: "#4D55BD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#3940AB"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#teams_ico-a)",
  d: "M3.33076249,0 L36.6458195,0 C38.4853637,0 39.9765819,1.49125329 39.9765819,3.33076249 L39.9765819,36.6458195 C39.9765819,38.4853637 38.4853287,39.9765819 36.6458195,39.9765819 L3.33076249,39.9765819 C1.49121823,39.9765819 0,38.4853287 0,36.6458195 L0,3.33076249 C0,1.49125329 1.49125329,0 3.33076249,0 Z"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#FFF",
  points: "28.754 12.68 22.094 12.68 22.094 30.815 17.851 30.815 17.851 12.68 11.223 12.68 11.223 9.162 28.754 9.162"
}));

var SvgTeamsIco = function SvgTeamsIco(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTeamsIco, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/teams_ico.16493361.svg";
export { ForwardRef as ReactComponent };